<ion-header class="permission-modal__header" translucent>
  <ion-toolbar color="primary">
    <ion-title>
      <div class="permission-modal__title-wrapper">
        <ion-icon name="shield-checkmark" class="title-icon"></ion-icon>
        <span>{{ "PERMISSIONS.STEPPER.TITLE" | translate }}</span>
      </div>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="permission-modal__content" [scrollEvents]="true">
  <div class="permission-modal__intro">
    <div class="intro-icon-wrapper">
      <ion-icon name="information-circle" class="intro-icon"></ion-icon>
    </div>
    <h3 class="intro-title">{{ "PERMISSIONS.STEPPER.TITLE" | translate }}</h3>
  </div>

  <div class="permission-list">
    <div
      *ngFor="let perm of permissionItems; trackBy: trackByKey"
      class="permission-card"
      [class.permission-card--granted]="permGranted(perm.key)"
    >
      <div class="permission-card__header">
        <div class="permission-icon-wrapper" [class.permission-icon-wrapper--granted]="permGranted(perm.key)">
          <ion-icon [name]="perm.icon" class="permission-icon"></ion-icon>
        </div>
        <div class="permission-card__info">
          <h3 class="permission-title">{{ perm.title | translate }}</h3>
          <p class="permission-description">{{ perm.description | translate }}</p>
        </div>
      </div>

      <div class="permission-card__footer">
        <ion-button
          class="permission-button"
          size="default"
          [disabled]="permGranted(perm.key)"
          (click)="handleAction(perm.key)"
        >
          {{ permGranted(perm.key) ? ("PERMISSIONS.STEPPER.DONE" | translate) : (perm.buttonLabel | translate) }}
        </ion-button>
      </div>
    </div>
  </div>

  <div class="permission-modal__progress" *ngIf="getProgressPercentage() < 100">
    <div class="progress-info">
      <span class="progress-text">{{ getGrantedCount() }}/{{ getTotalCount() }}</span>
      <span class="progress-percentage">{{ getProgressPercentage() }}%</span>
    </div>
    <div class="progress-bar-wrapper">
      <div class="progress-bar" [style.width.%]="getProgressPercentage()"></div>
    </div>
  </div>
</ion-content>

<ion-footer class="permission-modal__footer">
  <ion-toolbar>
    <ion-button expand="block" color="primary" class="dismiss-button" (click)="dismiss()">
      {{ "PERMISSIONS.STEPPER.SKIP" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
